import { theme } from "@monthly/theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";

import { ApiClientProvider } from "~/lib/api/axios-client";
import { env } from "~/lib/env";
import { queryClient } from "~/lib/react-query-client";
import type { RouterContext } from "~/router";
import { routeTree } from "~/routeTree.gen";

// Create router instance with query client context
const router = createRouter({
  routeTree,
  context: {
    queryClient,
  } as RouterContext,
  defaultPreload: "intent",
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ApiClientProvider baseURL={env.VITE_API_URL}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </ApiClientProvider>
    </ThemeProvider>
  );
}
